import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
    deleteParagraph: {
        marginTop: '2rem',
    },
    roleDeleteInput: {
        marginTop: '1rem',
    },
}));
